@if (isLoading) {
  <div class="spinner">
    <mat-card appearance="outlined">
      <mat-card-title>Chargement</mat-card-title>
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </mat-card>
  </div>
}
@if (!isLoading) {
  <div>
    <mat-card appearance="outlined">
      @if (typeRetour==='ok' && !error) {
        <div>
          <mat-card-title><mat-icon style="color: #18d82e;">check_circle</mat-icon> Paiement effectué</mat-card-title>
          <mat-card-content>
            <p>
              Votre paiement a bien été opéré. Voici les données récapitulatives:<br/>
              Identifiant de transaction: {{ order.paymentReference }}<br/>
              Montant: {{ order.amountPaid | number:'1.2':'fr-FR' }}€<br/>
            </p>
            <button mat-raised-button class='button-recap' onclick='window.print()'>Imprimer</button><br>
            <button mat-raised-button class='button-recap' (click)='sendMail()'>Envoyer par email</button>
          </mat-card-content>
        </div>
      }
      @if (typeRetour==='err' && !error) {
        <div>
          <mat-card-title><mat-icon style="color: #e70d0d;">cancel</mat-icon> Paiement annulé</mat-card-title>
          <mat-card-content>
            <p>Votre paiement a bien été annulé.</p>
            @if (!isAuthenticated()) {
              <div>
                <button mat-raised-button routerLink="login">Se connecter</button>
              </div>
            }
          </mat-card-content>
        </div>
      }
      @if (error && order!==null) {
        <div>
          <mat-card-title>Transaction en erreur</mat-card-title>
          <mat-card-content>
            <p>
              Une erreur a eu lieu pour la transaction : {{ order.paymentReference }}<br/>
              Montant: {{ order.amountPaid | number:'1.2':'fr-FR' }}€<br/>
              Merci de vous rapprocher de votre agence
            </p>
          </mat-card-content>
        </div>
      }
      @if (error && order===null) {
        <div>
          <mat-card-title>Transaction en erreur</mat-card-title>
          <mat-card-content>
            <p>
              Une erreur s'est produit lors votre tentative de paiement
              Merci de vous rapprocher de votre agence
            </p>
          </mat-card-content>
        </div>
      }
    </mat-card>
  </div>
}
